<template>
    <v-container>
        <v-btn :href=igAuthURL> 
            Login to IG
        </v-btn>
        <v-btn @click="postIG"> 
            get access tokens
        </v-btn>
          <v-chip-group column>
            <v-chip style="white-space:normal;" v-for="item in items2" :key="item.message" v-bind:class="{ height_auto: (item.message.length>43),'py-2': (item.message.length>43) }">
             
                    <v-avatar left>
                      <v-icon color="#4267B2">fab fa-facebook</v-icon>
                      <!-- <v-img :src="require('./assets/logo.png')"></v-img> -->
                    </v-avatar>
                  
                  {{ item.from.name }}
                  <v-subheader ><span>{{ item.message }}
                    </span></v-subheader>
            </v-chip>
          </v-chip-group>   
          </v-container>
</template>
<style>
.height_auto{
    height: auto !important;
    /* padding: 2px 0 !important; */
}
</style>
<script>
  export default {
    name: "FbSession",
    data(){
      return {
        // alignment: 'start',
        // dense: false,
        igAPIPath: "https://api.instagram.com/oauth/authorize/?",
        igAuthURL: "",
        items: [
          {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
          {name:"ccsy3", message:"text msg"}
        ],
        items2: [
        //   {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
        //   {name:"ccsy3", message:"text msg"}
        ],
        justify: 'space-between',
      };
    },
    methods:{
            postIG: function(){
                //发送 post 请求
                // var ig_code = "AQDac9WBPwK_vxBM4CVBaFttVgBrVP4O0r9RLGY1ZgYsxYSKVyc87HeLiGxf6NQhL43d8F9EAG1Z6BmPagO0mDo4ec37f9IUUCYZ8hZkxGclmPxe6H9haYTxXodBUHqLULWYIT0x0YgSFPyeYb_os776Vr7V1-6uD6YMojJyqz8AqU1GAAOi1tEEUU1OYvW8PiTiaTCkP723qkmnXeb65NYnGqGtYQiBmwYi5xguRDTExg#_";

                this.$http.post('https://api.instagram.com/oauth/authorize',{
                    client_id:"2774319549346365", 
                    redirect_uri:"https://cccomment.ccsy-ben.com/",
                    response_type:"token"
                },
                // {client_id:"2774319549346365",client_secret:"80ae89d4f41a6a61d96de35801c66736",
                // grant_type:"authorization_code",redirect_uri:"https://cccomment.ccsy-ben.com/", code:ig_code, callback:"?"},
              {  headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          'Access-Control-Allow-Headers': 'DNT,X-CustomHeader,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type'
        }}
        ).then(function(res){
                    console.log(res.body);    
                },function(res){
                    console.log(res.status);
                });
            }
        },
    mounted(){
        console.log(this.$route.query.token);
        var params = {
            client_id: 2774319549346365,
            redirect_uri: "https://cccomment.ccsy-ben.com/",
            scope: "user_profile,user_media",
            response_type: "code"
        }
       var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
       this.igAuthURL = this.igAPIPath+queryString;
       console.log(this.igAuthURL);
        // this.items.$set(0,{name:'adasdas'});
        // console.log(this.items);
        // 2774319549346365
       
// var authURL = " https://api.instagram.com/oauth/authorize
//   ?client_id=2774319549346365
//   &redirect_uri=https://cccomment.ccsy-ben.com/
//   &scope=user_profile,user_media
//   &response_type=code"
        //  var loginToken;
        
          

         (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },
  }
</script>

      